import { ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS } from 'src/modules/data-protection/constants';

export const settingsPath = `${ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS}?tab=email-settings`;
export const settingsQueryKey = 'data-protection-fetch-mailer-settings';
